import { get } from '@aiptyg/api-client';
import type { RewardListResponseDTO } from '../types/rewards.types';

export interface RewardListParams {
  source?: string;
  agentId?: string;
  page: number;
  pageSize: number;
  userId: string;
  range: string;
}

export function listRewards(params: RewardListParams): Promise<RewardListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  if (params.source) qs.set('source', params.source);
  if (params.agentId) qs.set('agent_id', params.agentId);
  qs.set('page_size', String(params.pageSize));
  if (params.userId) qs.set('user_id', params.userId);
  if (params.range) qs.set('range', params.range);
  return get<RewardListResponseDTO>(`/v1/admin/rewards?${qs.toString()}`);
}
